import {
  createCompany,
  deleteCompany,
  partialCompanyUpdate,
  selectSelectedCompany,
} from '@store/business/CompanyReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { formatPhoneNumberToE164FromPhoneInput } from '@utils/PhoneFormatter'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const CompanyForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.company)
  const dispatch = useAppDispatch()
  const selectedCompany = useAppSelector(selectSelectedCompany())

  const formatContactsPhone = (contacts: any[]) => {
    return contacts.map((contact) => {
      return {
        ...contact,
        phone: formatPhoneNumberToE164FromPhoneInput(contact.phone),
      }
    })
  }

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          const formattedContacts = formatContactsPhone(values.contacts)
          const finalData = {
            ...values,
            contacts: formattedContacts,
          }

          return dispatch(createCompany(finalData)).then(() => {
            return true
          })
        },
        update: async (values) => {
          const payload = {
            ...values,
            ...(values.phone && {
              phone: formatPhoneNumberToE164FromPhoneInput(values.phone),
            }),
            startAt:
              values.startAt && values.startAt.format('YYYY-MM-DD HH:mm:ss'),
          }
          return dispatch(partialCompanyUpdate(selectedCompany!, payload)).then(
            () => {
              return true
            }
          )
        },
        delete: async (values) =>
          dispatch(deleteCompany(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

CompanyForm.displayName = 'CompanyForm'

export default CompanyForm
